import { DeleteRegular, EditRegular } from '@fluentui/react-icons';
import {
  ClassService,
  UserListSorting,
  getSortedUserLabel,
  sortUsersByPreference,
} from '@mnspro-cloud/services';
import { times } from 'lodash';
import moment from 'moment-timezone';
import React, { FC } from 'react';

import { TagColorEnum } from '../../../Tags/Tags';
import {
  TeachingUnitEntry,
  TeachingUnitEntryType,
} from '../TeachingUnitEntry/TeachingUnitEntry';

export interface ClassServicesCardProps {
  service: ClassService;
  isLoading?: boolean;
  editClick?: (service: ClassService) => void;
  deleteClick?: (service: ClassService) => void;
  isDisabled: boolean;
  preferenceSorting?: UserListSorting;
}

export const ClassServicesCard: FC<ClassServicesCardProps> = props => {
  const { service, isLoading, editClick, deleteClick, isDisabled, preferenceSorting } = props;
  const dateFormat = 'DD.MM.YYYY';
  return (
    <>
      {isLoading &&
        times(2, index => (
          <TeachingUnitEntry
            key={`lesson-content-skeleton-${index}`}
            type={TeachingUnitEntryType.Services}
            headline=""
            loading
          />
        ))}
      {!isLoading && (
        <TeachingUnitEntry
          type={TeachingUnitEntryType.Services}
          headline={`${service.title} (${moment(service.start).format(
            dateFormat,
          )} - ${moment(service.end).format(dateFormat)})`}
          subheadline={service.content}
          tags={sortUsersByPreference(
            service.students,
            preferenceSorting ?? UserListSorting.FirstName,
          ).map(student => ({
            label: getSortedUserLabel(student, preferenceSorting ?? UserListSorting.FirstName),
            color: TagColorEnum.Grey,
          }))}
          onClick={!isDisabled ? () => editClick?.(service) : undefined}
          actions={
            isDisabled
              ? []
              : [
                  {
                    icon: <EditRegular />,
                    onClick: () => editClick?.(service),
                  },
                  {
                    icon: <DeleteRegular />,
                    onClick: () => deleteClick?.(service),
                  },
                ]
          }
        />
      )}
    </>
  );
};
